import type { FC } from 'react';
import React, { createContext, useContext, useMemo, useRef } from 'react';
import type {
    DemoDataContextProps,
    DemoDataContextProviderProps,
} from '@modules/dashboard/pages/kyc/docs-verification/docs-verification-page/providers/demo-data-provider/types';

export const DemoDataContext = createContext<DemoDataContextProps>({
    uploadFileRef: {
        current: async () => {},
    },
});

export const DemoDataContextProvider: FC<DemoDataContextProviderProps> = ({ children }) => {
    const uploadFileRef = useRef<(event: React.ChangeEvent<HTMLInputElement>) => Promise<void>>(
        async () => {},
    );

    const value = useMemo(() => ({ uploadFileRef }), []);

    return <DemoDataContext.Provider value={value}>{children}</DemoDataContext.Provider>;
};

export const useDemoData = () => {
    const { uploadFileRef } = useContext(DemoDataContext);

    return {
        uploadFileRef,
    };
};
